import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/instructor/exam/requests', config);
}
const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/instructor/exam/requests/' + id);
}
const prepareEntry = async (examType) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/instructor/exam/requests/prepare-entry/' + examType);
}
const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/instructor/exam/requests/' + id, formData);
}

const downloadAsExcel = (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/instructor/exam/requests/excel-export', {...config, responseType: 'arraybuffer'});
}

const remove = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/instructor/exam/requests/' + id)
}

export default {
    getAll,
    get,
    update,
    downloadAsExcel,
    prepareEntry,
    remove
}
